import { createContext } from "react";

/**
 * React context whose value is whether the local device has been verified.
 *
 * (Specifically, this is true if we have done enough verification to confirm that the published public cross-signing
 * keys are genuine -- which normally means that we or another device will have published a signature of this device.)
 *
 * This context is available to all components under {@link LoggedInView}, via {@link MatrixClientContextProvider}.
 */
export const LocalDeviceVerificationStateContext = createContext(false);
